import { createApp } from 'vue'
import { createPinia } from 'pinia'

const app = createApp({})
app.use(createPinia())

const files = require.context('@/components', true, /\.vue$/i)

files.keys().forEach((key) => {
    const name = key.split('/').pop().split('.')[0]
    app.component(name, files(key).default)
})

app.mount('#app')
